import { toast } from "sonner";
import { Link } from "react-router-dom";
import { Ticket } from "lucide-react";

export interface TicketNotificationProps {
  message: string;
  relatedTicketId: string;
  toastId?: string | number;
}

/**
 * Custom toast notification component for displaying tickets.
 *
 * Features:
 * - Displays message preview
 * - Navigates to ticket details when clicked
 * - Dismisses toast on click
 *
 * @param message - The notification message to display
 * @param relatedTicketId - The ID of the related ticket
 * @param toastId - Toast ID for dismissal (provided by Sonner)
 */
export const TicketNotification = ({ message, relatedTicketId, toastId }: TicketNotificationProps) => {
  return (
    <Link
      to={`/tickets/details/${relatedTicketId}`}
      onClick={() => {
        if (toastId !== undefined) {
          toast.dismiss(toastId);
        }
      }}
      className="flex gap-3 items-center cursor-pointer hover:bg-accent p-4 rounded-lg bg-background border border-border shadow-lg transition-colors min-w-[320px]"
      tabIndex={0}
    >
      <Ticket />
      {/* Content */}
      <div className="flex flex-col gap-1 flex-1 min-w-0">
        <p className="font-semibold text-sm truncate">{message}</p>
      </div>
    </Link>
  );
};
